__turbopack_context__.v({
  "addButton": "Product-module__j8dWUW__addButton",
  "addToCart": "Product-module__j8dWUW__addToCart",
  "count": "Product-module__j8dWUW__count",
  "counterBox": "Product-module__j8dWUW__counterBox",
  "deleteButton": "Product-module__j8dWUW__deleteButton",
  "main": "Product-module__j8dWUW__main",
});
